import campaignGraphicsQuery from "web/queries/default/campaignGraphics.graphql";
import cmsBlocksQuery from "web/queries/default/cmsBlocks.graphql";
import msAttributesQuery from "web/queries/ms/attributesByCodes.graphql";
import msCategoriesQuery from "web/queries/ms/categoriesByIds.graphql";
import categoryCountsQuery from "web/queries/ms/categoryCounts.graphql";
import msProductsDomesticTourismQuery from "web/queries/ms/listingProductsDomesticTourismByIds.graphql";
import msMenuClients from "web/queries/ms/menuClients.graphql";
import msMainMenuQuery from "web/queries/ms/menus.graphql";
import msProductsFullQuery from "web/queries/ms/productsByIds.graphql";
import msProductsIdsFacetsStatsQuery from "web/queries/ms/productsIdsFacetsStatsByCategoryId.graphql";
import msProductsShortQuery from "web/queries/ms/productsInListByIds.graphql";
import msProductsInWishlistQuery from "web/queries/ms/productsInWishlistByIds.graphql";
import productsTypesByIdsQuery from "web/queries/ms/productsTypesByIds.graphql";
import searchQuery from "web/queries/ms/search.graphql";

import { magentoUrlKey, msURlKey } from "web/constants/graphqlUrls";
import storageNames from "web/constants/storageNames";

import DataIndexDb from "./dataIndexDb";
import DataLocalStorage from "./dataLocalStorage";

const dbNameProducts = "FENIKS_PRODUCTS";
const dbNameCategories = "FENIKS_CATEGORIES";
const dbNameCampaignGraphics = "FENIKS_CAMPAIGNGRAPHICS";
const dbNameAttributes = "FENIKS_ATTRIBUTES";
const dbNameCategoryCounts = "FENIKS_CATEGORY_COUNTS";
const dbNameIdsFacetsStats = "FENIKS_IDS_FACETS_STATS";
const dbNameSearch = "FENIKS_SEARCH";
const dbNameProductsDomesticTourism = "FENIKS_PRODUCTS_DOMESTIC_TOURISM";
const dbNameProductsTypes = "FENIKS_PRODUCTS_TYPES";
const dbNameBlocks = "FENIKS_BLOCKS";
const dbNameWishlist = "FENIKS_WISHLIST";

const [
  productsStorage,
  categoriesStorage,
  categoryCountsStorage,
  campaignGraphicsStorage,
  attributesStorage,
  idsFacetsStatsStorage,
  searchStorage,
  productsDomesticTourismStorage,
  productsInListStorage,
  productsInWishlistStorage,
  productsTypesStorage,
  menuStorage,
  customerMenuStorage,
  cmsBlocksStorage,
] =
  window.indexedDB ||
  window.mozIndexedDB ||
  window.webkitIndexedDB ||
  window.msIndexedDB
    ? [
        new DataIndexDb({
          dbName: dbNameProducts,
          storeName: storageNames.products,
          query: msProductsFullQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameCategories,
          storeName: storageNames.categories,
          query: msCategoriesQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameCategoryCounts,
          storeName: storageNames.categoryCounts,
          query: categoryCountsQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameCampaignGraphics,
          storeName: storageNames.campaignGraphics,
          query: campaignGraphicsQuery,
          endpoint: magentoUrlKey,
          identifier: "graphic_id",
        }),
        new DataIndexDb({
          dbName: dbNameAttributes,
          storeName: storageNames.attributes,
          query: msAttributesQuery,
          endpoint: msURlKey,
          identifier: "attribute_code",
        }),
        new DataIndexDb({
          dbName: dbNameIdsFacetsStats,
          storeName: storageNames.idsFacetsStats,
          query: msProductsIdsFacetsStatsQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameSearch,
          storeName: storageNames.search,
          query: searchQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameProductsDomesticTourism,
          storeName: storageNames.productsDomesticTourism,
          query: msProductsDomesticTourismQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameProducts,
          storeName: storageNames.products,
          query: msProductsShortQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameWishlist,
          storeName: storageNames.wishlist,
          query: msProductsInWishlistQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameProductsTypes,
          storeName: storageNames.productsTypes,
          query: productsTypesByIdsQuery,
          endpoint: msURlKey,
        }),
        new DataIndexDb({
          dbName: dbNameBlocks,
          storeName: storageNames.blocks,
          query: msMainMenuQuery,
          endpoint: msURlKey,
          identifier: "block_id",
        }),
        new DataIndexDb({
          dbName: dbNameBlocks,
          storeName: storageNames.blocks,
          query: msMenuClients,
          endpoint: msURlKey,
          identifier: "block_id",
        }),
        new DataIndexDb({
          dbName: dbNameBlocks,
          storeName: storageNames.blocks,
          query: cmsBlocksQuery,
          endpoint: magentoUrlKey,
          identifier: "block_id",
        }),
      ]
    : [
        new DataLocalStorage(storageNames.products, msProductsFullQuery),
        new DataLocalStorage(storageNames.categories, msCategoriesQuery),
        new DataLocalStorage(storageNames.categoryCounts, categoryCountsQuery),
        new DataLocalStorage(
          storageNames.campaignGraphicsStorage,
          campaignGraphicsQuery,
          magentoUrlKey
        ),
        new DataLocalStorage(
          storageNames.attributes,
          msAttributesQuery,
          msURlKey
        ),
        new DataLocalStorage(
          storageNames.idsFacetsStats,
          msProductsIdsFacetsStatsQuery
        ),
        new DataLocalStorage(storageNames.search, searchQuery),
        new DataLocalStorage(
          storageNames.productsDomesticTourism,
          msProductsDomesticTourismQuery
        ),
        new DataLocalStorage(storageNames.products, msProductsShortQuery),
        new DataLocalStorage(storageNames.wishlist, msProductsInWishlistQuery),
        new DataLocalStorage(
          storageNames.productsTypes,
          productsTypesByIdsQuery
        ),
        new DataLocalStorage(storageNames.blocks, msMainMenuQuery),
        new DataLocalStorage(storageNames.blocks, msMenuClients),
        new DataLocalStorage(storageNames.blocks, cmsBlocksQuery),
      ];

export {
  productsStorage,
  categoriesStorage,
  categoryCountsStorage,
  campaignGraphicsStorage,
  attributesStorage,
  idsFacetsStatsStorage,
  searchStorage,
  productsDomesticTourismStorage,
  productsInListStorage,
  productsInWishlistStorage,
  productsTypesStorage,
  menuStorage,
  customerMenuStorage,
  cmsBlocksStorage,
};

export const clearAllData = async () => {
  return Promise.all([
    productsStorage.clear(),
    attributesStorage.clear(),
    categoriesStorage.clear(),
    categoryCountsStorage.clear(),
    campaignGraphicsStorage.clear(),
    idsFacetsStatsStorage.clear(),
    searchStorage.clear(),
    productsDomesticTourismStorage.clear(),
    productsTypesStorage.clear(),
    productsInListStorage.clear(),
    productsInWishlistStorage.clear(),
    menuStorage.clear(),
    customerMenuStorage.clear(),
    cmsBlocksStorage.clear(),
    sessionStorage.clear(),
  ]);
};

export const clearTranslatedData = () => {
  return Promise.all([
    productsStorage.clear(),
    attributesStorage.clear(),
    categoriesStorage.clear(),
    sessionStorage.clear(),
    campaignGraphicsStorage.clear(),
    productsInListStorage.clear(),
    productsInWishlistStorage.clear(),
  ]);
};
